/* unplugin-vue-components disabled */import { render } from "./why.vue?vue&type=template&id=ac7212d8&scoped=true"
import script from "./why.vue?vue&type=script&lang=js"
export * from "./why.vue?vue&type=script&lang=js"

import "./why.vue?vue&type=style&index=0&id=ac7212d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7212d8"]])

export default __exports__